import React from "react";
import "./About.css";
import { motion } from "framer-motion";
import ProfileImage from "./ProfileImage";
import { AboutCard, AboutContainer, AboutfadeUp, motionProps } from "../../animations";
import { aboutCards, aboutText } from "../../data/about.data";
import AnimatedHeadings from "../animatedHeadings/AnimatedHeadings";

const About = () => {
  return (
    <section id="about">
      <AnimatedHeadings smallTitle="Get To Know" mainTitle="About Me" />

      {/* Container */}
      <motion.div className="container about__container" variants={AboutContainer} {...motionProps}>
        {/* Profile Image */}
        <ProfileImage />

        {/* Content */}
        <motion.div className="about__content" variants={AboutfadeUp}>
          {/* Cards */}
          <motion.div className="about__cards">
            {aboutCards.map(({ icon: Icon, title, description }) => (
              <motion.article key={title} className="about__card" variants={AboutCard}>
                <Icon className="about__icon" />
                <h5>{title}</h5>
                <small>{description}</small>
              </motion.article>
            ))}
          </motion.div>

          {/* Paragraph */}
          {aboutText.map((text, i) => (
            <motion.p key={i} variants={AboutfadeUp} transition={{ duration: 0.8, delay: i * 0.2 }}>
              {text}
            </motion.p>
          ))}

          {/* CTA Button */}
          <motion.a
            href="#contact"
            className="btn btn-primary contact__btn"
            variants={AboutfadeUp}
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          >
            Let's Talk
          </motion.a>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default About;
